import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  // 首页
  {
    path: '/',
    redirect: '/account'
  },
  // 登录注册忘记密码 快速创建
  {
    path: '/account',
    component: () => import('../views/account'),
    redirect: '/account/login&register',
    children: [
      {
        // 登录与注册
        path: 'login&register',
        component: () => import('../views/account/loginAndRegister')
      },
      {
        // 忘记密码
        path: 'forgetpassword',
        component: () => import('../views/account/forgetPassword')
      },
      {
        // 快速注册和绑定账号
        path: 'newaccount',
        component: () => import('../views/account/newAccount')
      }
    ]
  },
  // 登录之后
  {
    path: '/afterlogin',
    component: () => import('../views/afterLogin'),
    children: [
      {
        // 激活邮箱
        path: 'activateemail',
        component: () => import('../views/afterLogin/activateEmail')
      },
      {
        // 邮件链接页面
        path: 'emailactivated',
        component: () => import('../views/afterLogin/emailActivated')
      }
    ]
  },
  // 【第三方登陆】和【绑定第三方】中转页面
  {
    path: '/callback',
    component: () => import('../views/callback')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  next()
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js